import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { ExpressShipping } from "./ExpressShipping";
import { MailShipping } from "./MailShipping";
import { StandardShipping } from "./StandardShipping";
import { useAuth } from "../../../../Context/AuthContext";
import { ChangeOfAddressType } from "../../../../constants";
import { CheckPoBox } from "../../../../Layout/Common/common";
import { axiosInstance } from "../../../../axios/axiosInstance";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { useNoteAlert } from "../../../../Context/pleaseNote";
import Skeleton from "react-loading-skeleton";
import { useGlobalFunction } from "../../../../Context/GlobalFunctionContext";
import { ShippingInformation } from "./shippingInformation";
import { globalEval } from "jquery";
import { useParams } from "react-router-dom";
import { takePendingShipServiceKey } from "../../../../Context/hook/tillRedirect";

export const ShippingService = () => {
  const [shipMethod, setShipMethod] = useState(null);
  const [selected, setSelected] = useState(null);
  const { userId } = useAuth();
  const { showNoteAlert } = useNoteAlert();
  const globalcontext = useContext(GlobalContext);
  const { setSelectedShipService, clearSelectedShipService } = useGlobalFunction();
  const { orderId } = useParams();
  const adminPickedServiceRef = useRef(false);

  const cartSignature = globalcontext.CartItem
    ? [
        globalcontext.CartItem.orderid ?? "",
        globalcontext.CartItem.totalcost ?? "",
        globalcontext.CartItem.totalItem ?? "",
      ].join("~")
    : "";
  useEffect(() => {
    if (!orderId) setSelectedShipService(null);
  }, [orderId, globalcontext.shippingMode]);
  useEffect(() => {
    setShipMethod(null);
    setSelected(null); // reset selection

    let address = globalcontext.shippingAddress;

    if (address) {
      const data = {
        userId: String(userId),
        IsDropShipment: ChangeOfAddressType.dropShippment == globalcontext.addressType,
        hfchangeofaddress: ChangeOfAddressType.changeOfAddress == globalcontext.addressType,
        hfshipcode: address.shipZip,
        postcode: address.shipZip,
        suburb: address.shipCity,
        addressLine1: address.shipAddress1,
        addressLine2: address.shipAddress2,
        ispobox: CheckPoBox(address.shipAddress1 + address.shipAddress2),
        shipAddress: address,
        orderId: orderId ?? "0",
      };

      if (!orderId) clearSelectedShipService();

      axiosInstance
        .post("Shipping/loadshipservice", data)
        .then((response) => {
          if (response.data) {
            setShipMethod(response.data);
            const restoredKey = takePendingShipServiceKey();
            if (restoredKey) {
              const match = response.data.find((item) => item.key === restoredKey);
              if (match) setSelectedShipService(match);
            }
          }
        })
        .catch((error) => console.log(error.message));
    }
  }, [globalcontext.addressType, globalcontext.shippingAddress, cartSignature]);

  const handleSelection = (e, item) => {
    if (globalcontext.shippingMode && globalcontext.shippingMode.includes(item.value)) {
      return;
    }

    if (globalcontext.aerosol != "" && globalcontext.aerosol != null) {
      if (String(item.key).includes("express")) {
        e.preventDefault();
        showNoteAlert("Courier Express not available for product code : " + globalcontext.aerosol.join(" ,"));
        return;
      } else {
        showNoteAlert(
          "This order contain items that are classified as dangerous goods and can only be sent by road freight. Products flagged as dangerous are: " +
            globalcontext.aerosol.join(" ,"),
        );
        setSelectedShipService(item);
      }
    } else {
      setSelectedShipService(item);
    }

    if (String(item.key).includes("mail")) {
      showNoteAlert(
        "Mail will be used for parcels up to 500 grams including packaging. Parcels over 500 grams will be sent by the most economical way e.g., Courier, Road, etc.",
      );
    }
  };

  return (
    <div className="selected-shipping-method">
      <h3>
        Shipping Service
        <p data-bs-toggle="modal" data-bs-target="#shippingMethod">
          <i className="fa-solid fa-circle-info" />
        </p>
      </h3>

      <ShippingInformation />

      <div className="shipping-method-list">
        {shipMethod ? (
          shipMethod.map((item, index) => (
            <div className={`shipping-method`} key={index}>
              <div className="shipping-method-info" style={{ width: "100%" }}>
                <div>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="shippingMethod"
                    id={item.key}
                    value={item.value}
                    checked={globalcontext.shippingMode === item.value}
                    readOnly
                    onClick={(e) => handleSelection(e, item)}
                  />
                </div>

                <label className="form-check-label" htmlFor={item.key}>
                  <div className={"d-flex justify-content-between align-items-center"}>
                    <div>{item.value}</div>
                    <div>
                      {item.cost ? (
                        item.shipcode === "TBA" ? (
                          "Cost To Be Advised"
                        ) : (
                          `$ ${item.cost}`
                        )
                      ) : (
                        <Skeleton width={50} />
                      )}
                    </div>
                  </div>
                </label>
              </div>
            </div>
          ))
        ) : (
          <Fragment>
            <StandardShipping />
            <ExpressShipping />
            <MailShipping />
          </Fragment>
        )}
      </div>
    </div>
  );
};
